import { Button, Container, Typography } from '@pwskills/rachnaui';
import { useRouter } from 'next/router';
import { useContext, useState } from 'react';
import LeadCapture from '@/components/common/LeadCapture';
import CheckMarkIcon from '@/assets/icons/CheckMarkIcon';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { ICourseAboutPointers, IPartnerInstituteDetails } from '@/interfaces/courseDescription';
import { LeadCaptureEnquiryType, LeadCaptureType, ModalType } from '@/interfaces/leadCapture.enum';
import SocialShareModal from '../../common/SocialShareModal';
import { DOMAIN } from '../../../utils/homePage/env.constants.utils';

const HeroSection = () => {
  const router = useRouter();
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { title, partnerInstituteDetails, isPremiumOnlineDegreeCourse } = courseDetails || {};

  const instituteDetails: IPartnerInstituteDetails = partnerInstituteDetails
    ? partnerInstituteDetails[0]
    : { instituteLogoFileName: '', name: '' };

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const slug = router?.query?.degreeSlug;

  // const getBreadcrumbs = () => {
  //   const isFromPage = router?.query?.from;

  //   if (isFromPage === 'online-degree-page') {
  //     // If the user comes from the /online-degree route
  //     return (
  //       <div className="flex items-center gap-1">
  //         <div className="flex gap-1 justify-center items-center text-gray-650  ">
  //           <Home className="w-3 h-3 text-white" />
  //           <Typography
  //             component="body-small"
  //             variant="regular"
  //             className="text-white cursor-pointer  whitespace-nowrap"
  //             onClick={() => {
  //               router.push('/');
  //             }}
  //           >
  //             Home {`>`}
  //           </Typography>
  //         </div>
  //         <Typography
  //           component="body-small"
  //           variant="regular"
  //           className="text-white cursor-pointer  whitespace-nowrap"
  //           onClick={() => {
  //             router.push('/online-degree');
  //           }}
  //         >
  //           IIT & IIM Online Programs {`>`}
  //         </Typography>
  //         <Typography
  //           component="body-small"
  //           variant="bold"
  //           className="text-white whitespace-nowrap  overflow-hidden text-ellipsis"
  //         >
  //           {title}
  //         </Typography>
  //       </div>
  //     );
  //   }

  //   // If the user comes directly from anwhere else
  //   return (
  //     <div className="flex items-center gap-1">
  //       <div className="flex gap-1 justify-center items-center text-gray-650  ">
  //         <Home className="w-3 h-3 text-white" />
  //         <Typography
  //           component="body-small"
  //           variant="regular"
  //           className="text-white cursor-pointer whitespace-nowrap"
  //           onClick={() => {
  //             router.push('/');
  //           }}
  //         >
  //           Home {`>`}
  //         </Typography>
  //       </div>
  //       <Typography
  //         component="body-small"
  //         variant="bold"
  //         className="text-white whitespace-nowrap  overflow-hidden text-ellipsis"
  //       >
  //         {title}
  //       </Typography>
  //     </div>
  //   );
  // };

  return (
    <div className="relative w-full h-fit" id="overview">
      <Container
        id="category-hero-section"
        className="!py-8 medium:!py-14 flex flex-col gap-6 medium:gap-9 !px-4 medium:!px-8 large:!px-20 "
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[rgb(27,33,36)]" />
        {/* <Image
          className="absolute left-0 top-0 w-full z-0  h-full bg-cover "
          src="/images/degreeDescription/degreeDescriptionHeroBg.webp"
          alt="hero image"
          width={1000}
          height={600}
        /> */}

        <div className="absolute left-0 top-0 w-full h-full bg-cover !bg-gradient-to-b  from-[#222222]  to-[#1E1D1DB3] z-0" />
        <div className="flex flex-col large:!flex-row large:!justify-between">
          <div
            className={`flex flex-col gap-9 large:gap-[96px] z-[1] ${
              !isPremiumOnlineDegreeCourse ? '' : 'justify-center'
            }`}
          >
            {!isPremiumOnlineDegreeCourse}
            <div className="flex flex-col gap-6 w-full regular:!w-[628px]">
              <div className="flex gap-2 items-center">
                <div className="bg-[#B2B2B233] rounded px-[7.8px] py-[2.5px]  border-[0.5px] border-white">
                  <img
                    src={instituteDetails?.instituteLogoFileName}
                    alt="collage-logo"
                    className="!w-6 !h-6"
                  />
                </div>

                <Typography
                  variant="regular"
                  component="h4"
                  className="text-white !text-[14px] !leading-[22px] medium:!text-[20px] medium:!leading-[30px]"
                >
                  {instituteDetails?.name}
                </Typography>
              </div>
              <Typography
                variant="bold"
                component="h1"
                className="text-white !text-[24px] !leading-[36px]  medium:!text-[32px] medium:!leading-[40px]"
              >
                {title}
              </Typography>
              <div className="flex flex-wrap gap-x-4 gap-y-4 medium:gap-y-6 ">
                {courseDetails?.courseMetaDetails?.about?.coursePointers &&
                  courseDetails?.courseMetaDetails?.about?.coursePointers?.map(
                    (pointer: ICourseAboutPointers) => {
                      return (
                        <div className="flex flex-col gap-2 pr-4 py-2 w-full medium:!w-[302px]">
                          <div className="flex gap-2 items-center">
                            <CheckMarkIcon />
                            <Typography
                              variant="bold"
                              component="body-regular"
                              className="text-white"
                            >
                              {pointer.title}
                            </Typography>
                          </div>
                          <Typography
                            variant="regular"
                            component="body-small"
                            className="text-white opacity-80 line-clamp-2 !text-[14px] !leading-[22px]"
                          >
                            {pointer.subText}
                          </Typography>
                        </div>
                      );
                    }
                  )}
              </div>
              {!isPremiumOnlineDegreeCourse && (
                <Button
                  size="medium"
                  className="w-full medium:!w-fit !px-6 !py-3"
                  onClick={() => {
                    setModalOpen(true);
                  }}
                >
                  Share now
                </Button>
              )}
            </div>
          </div>

          <SocialShareModal
            modelOpen={modalOpen}
            setModelOpen={setModalOpen}
            url={`${DOMAIN}/degree/${slug}`}
            title=""
          />

          <div className="h-[662px] w-full mt-6 medium:!mt-[56px] large:!mt-0 large:!w-[412px] !z-[2]">
            <LeadCapture
              leadCaptureType={LeadCaptureType.FORM}
              // modelOpen={openModal}
              // setModelOpen={setOpenModal}
              buttonText="Get Free Counselling"
              msgLineOne="We Got Your Query."
              msgLineTwo="Our Counsellor will reach out soon"
              type="CategoryPageConnect"
              enquiryType={LeadCaptureEnquiryType.ONLINE_DEGREE_GET_COUNSELLING}
              enquiryTypeNPF="Online Degree_getcounselling"
              modalType={ModalType.ONLINE_DEGREE}
              pageName="degree_description"
              sourceName="online_degree_get_counselling"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;
